<template>
  <div class="user-card transaction">
    <div v-if="tableData.length === 0" class="no-data">
      No Data
    </div>
    <div v-for="(row,index) in tableData" :key="index" class="row">
      <div class="left">
        <div class="amount">
          {{ row.amount | formatMoney }}
        </div>
        <div class="time">
          {{ row.type }}
        </div>
      </div>
      <div class="right">
        <div class="date">
          {{ row.date }}
        </div>
        <div class="status">
          {{ row.status }}
        </div>
      </div>
      <div v-if="amInWhiteList" class="left remark">Remark: {{ row.remark}}</div>
      <div v-if="amInWhiteList" class="right edit-icon">
        <md-icon name="edit" size="md" @click="openRemarkDialog(row.id)"></md-icon>
      </div>
    </div>
    <md-popup v-model="showRemarkDialog" position="bottom">
      <div class="dialog">
        <div class="label">Remark:</div>
        <md-field>
          <md-input-item
            name="remark"
            class="bordered mobile-input"
            v-model="remarkForm.remark"
          >
          </md-input-item>
        </md-field>
        <md-button type="primary" round class="btn-do" @click="submitRemark">
          Submit
        </md-button>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { Button, Field, Popup, InputItem } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        amount: 'Amount',
        status: 'Status',
        transactionDate: 'Transaction date',
        type: 'Type',
        ACTIVE: 'Pending',
        CLOSED: 'Closed',
        INVEST: 'Invest',
        MATCHED: 'Finished',
        PENDING: 'Pending',
        FAILED: 'Failed',
        REPAID: 'Finished',
        REPAYMENT: 'Repayment',
        TOP_UP: 'Top up',
        TRANSFERED: 'Succeed',
        TRANSFERRED: 'Succeed',
        WITH_DRAW: 'Withdraw',
        COUPON_TOP_UP: 'Cash voucher reward',
      },
      id: {
        amount: 'Jumlah',
        status: 'Status',
        transactionDate: 'Tanggal transaksi',
        type: 'Jenis',
        ACTIVE: 'Tertunda',
        CLOSED: 'Gagal',
        INVEST: 'Pendanaan',
        MATCHED: 'Selesai',
        PENDING: 'Tertunda',
        FAILED: 'Gagal',
        REPAID: 'Selesai',
        REPAYMENT: 'Pelunasan',
        TOP_UP: 'Penyaluran Dana',
        TRANSFERED: 'Berhasil',
        TRANSFERRED: 'Berhasil',
        WITH_DRAW: 'Penarikan Dana',
        COUPON_TOP_UP: 'Hadiah voucher tunai',
      },
    },
  },
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [InputItem.name]: InputItem,
  },
  data() {
    return {
      whiteList: ['5c2f328afe179d090f2ed0db'],
      tableData: [],
      tableType: null,
      tableState: null,
      showRemarkDialog: false,
      remarkForm: {
        id: null,
        remark: '',
      },
    }
  },
  computed: {
    amInWhiteList() {
      return this.whiteList.includes(this.$store.state.userInfo.id)
    },
    currencyType() {
      return this.$store.state.currency
    },
    accountInfo() {
      const { accountOverview } = this.$store.state
      return (
        accountOverview.find(account => {
          return account.currencyType === this.$store.state.currency
        }) || {}
      )
    },
  },
  async mounted() {
    await this.reloadTableData()
  },
  methods: {
    async reloadTableData() {
      try {
        const params = {
          pageNum: 1,
          pageSize: 1000,
          accountId: this.accountInfo.id,
          type: this.tableType,
          state: this.tableState,
        }
        const response = await this.$http.get('/transaction/list', { params }) || []
        this.tableData = response.data.data.map(value => {
          return {
            id: value.id,
            date: this.moment(value.createTimestamp).format('YYYY-MM-DD HH:mm:ss'),
            type: this.$t(value.type),
            amount: value.amount,
            remark: value.remark,
            status: this.$t(value.status),
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    openRemarkDialog(id) {
      this.showRemarkDialog = true
      this.remarkForm.id = id
    },
    async submitRemark(row) {
      try {
        this.showRemarkDialog = false
        await this.$http.post('/transaction/remark', this.remarkForm)
        this.remarkForm = {
          id: null,
          remark: '',
        }
        await this.reloadTableData()
      } catch (error) {
        console.error(error)
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.reloadTableData()
    })
  },
}
</script>

<style lang="stylus" scoped>
.transaction {
}

.row {
  box-sizing: content-box;
  padding: 30px 10px;
  border-bottom: 1px solid #ccc;

  .left {
    width: 55%;
    display: inline-block;
    vertical-align: top;

    .amount {
      /deep/ span {
        font-weight: bold;
      }

      font-size: 20px;
      margin-bottom: 10px;
    }

    .time {
    }
  }

  .right {
    text-align: right;
    width: 45%;
    display: inline-block;
    vertical-align: top;

    .date {
      margin-bottom: 10px;
    }

    .status {
    }
  }

  .remark {
    width 80%
    margin 10px 0 0
    font-size 16px
    word-break break-all
  }

  .edit-icon {
    width 20%
    margin 10px 0 0
  }
}

.no-data {
  text-align: center;
  padding: 20px;
}

.dialog {
  background #fff
  padding 30px
  .label {
    font-size 18px
    padding 0 0 10px 0
  }
  .btn-do {
    margin: 30px 0 0
  }
}
</style>
